import axios from 'axios';
import store from 'store';
import router from '../../router';

const state = {
  permissions: [],
  filtersLoaded: false,
};

const getters = {};

const mutations = {
  setPermissions: (st, payload) => {
    st.permissions = payload;
  },
  setFiltersLoaded: (st, payload) => {
    st.filtersLoaded = payload;
  },
};

const actions = {
  getPermissions({ commit, dispatch }, payload) {
    axios
      .get(`clusters/users/${payload.id}/permissions`)
      .then(res => {
        const perm = res.data.data.map(el => el.name);
        commit('setPermissions', perm);
        store.set('permissions', perm);
        Promise.all([
          dispatch('getCarriers'),
          dispatch('getClusterUsers'),
          dispatch('getCompanies'),
          dispatch('getCompanyStatuses'),
          dispatch('getDiscountUnitTypes'),
          dispatch('getJobStatuses'),
          dispatch('getMoveSizes'),
          dispatch('getRoles'),
          dispatch('getSources'),
          dispatch('getUserStatuses'),
        ]).then(() => {
          if (store.get('permissions').indexOf('jobs.plans.index') >= 0) {
            dispatch('getPlans');
          }
          commit('setFiltersLoaded', true);
        });
      })
      .catch(() => {
        store.remove('dispatchUser');
        store.remove('jwtToken');
        store.remove('permissions');
        router.push('/login');
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/guard.js